import React, { Component } from 'react';
import { string, func, arrayOf, shape, bool, oneOf } from 'prop-types';
import classnames from 'classnames';
import { connectSortBy } from 'react-instantsearch-core';
import { SortingList, SortingBar } from './components';
import {
    getGroupedIndexes,
    hasIndexChanged,
    SORTING_MODE,
} from './Sorting.util';

class Sorting extends Component {
    static propTypes = {
        className: string,
        items: arrayOf(
            shape({
                label: string,
                isRefined: bool,
                value: string,
            }),
        ).isRequired,
        refine: func.isRequired,
        currentRefinement: string,
        groupIndexes: bool,
        mode: oneOf([SORTING_MODE.BAR, SORTING_MODE.LIST]),
    };

    static defaultProps = {
        className: null,
        currentRefinement: null,
        groupIndexes: false,
        mode: SORTING_MODE.BAR,
    };

    shouldComponentUpdate(nextProps) {
        const { className, items } = this.props;
        return (
            nextProps.className !== className ||
            hasIndexChanged(nextProps.items, items)
        );
    }

    handleSortItemClick = indexName => {
        const { refine, items } = this.props;
        const newSortIndex = items.find(
            sortItem => sortItem.value === indexName,
        );
        if (!newSortIndex.isRefined) {
            refine(newSortIndex.value);
        }
    };

    handleSelectChange = evt => this.handleSortItemClick(evt.target.value, evt);

    render() {
        const {
            className,
            items,
            currentRefinement,
            groupIndexes,
            mode,
        } = this.props;

        const rootClassnames = classnames('sorting-root', className);
        const groupedIndexes = groupIndexes ? getGroupedIndexes(items) : items;
        return mode === SORTING_MODE.LIST ? (
            <SortingList
                className={rootClassnames}
                currentRefinement={currentRefinement}
                handleClick={this.handleSortItemClick}
                groupedIndexes={groupedIndexes}
            />
        ) : (
            <SortingBar
                currentRefinement={currentRefinement}
                onClick={this.handleSelectChange}
                groupedIndexes={groupedIndexes}
            />
        );
    }
}

export default connectSortBy(Sorting);
